import OccupationTab from './OccupationTab';

export default OccupationTab;
